import { render, staticRenderFns } from "./tabFanExperience.vue?vue&type=template&id=61f7fd1b&scoped=true&"
import script from "./tabFanExperience.vue?vue&type=script&lang=js&"
export * from "./tabFanExperience.vue?vue&type=script&lang=js&"
import style0 from "./tabFanExperience.vue?vue&type=style&index=0&id=61f7fd1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f7fd1b",
  null
  
)

export default component.exports